<template>
    <layout>
        <template slot="title">
            <v-avatar size="45px" tile><img src="/logo.png" alt="" title="" /></v-avatar> {{trans('layout.title')}}
        </template>
        <template slot="header">
            <select-locale class="mx-2"></select-locale>
        </template>
        <slot></slot>
        <template slot="footer">
            {{trans('layout.footer')}}
        </template>
    </layout>
</template>
<script>
import AppLayout from "./layout/AppLayout";
import SelectLocale from "./SelectLocale";

export default {
    props: {},
    data() {
        return {};
    },
    computed: {},
    methods: {},
    watch: {},
    filters: {},
    components:{
        SelectLocale,
        layout:AppLayout,
    }
}
</script>
